import { useTranslation } from 'react-i18next';
import { Modal } from '../UI';
import { Button } from '../UI/base/Button';
import modalStyles from '../UI/Modal.module.css';
import { DELETE_LOCATION_MODAL_WIDTH } from './locationsConstants';
import styles from './DeleteLocationModal.module.css';

interface DeleteLocationModalProps {
  locationName: string;
  // Returning the delete promise keeps the confirm button disabled until it
  // settles (see UI/base/Button), so a slow request cannot be fired twice.
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

// NOTE: the copy says the location is removed permanently. The backend archives
// it instead (its ADR 0005: the row leaves every listing and releases its name,
// but scenarios, patients and bookings that reference it are kept). The copy is
// accurate from the operator's side — it is gone and does not come back — so it
// is left as the designer wrote it.

export const DeleteLocationModal = ({
  locationName,
  onConfirm,
  onClose
}: DeleteLocationModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('delete-location-title')}
      onClose={onClose}
      width={DELETE_LOCATION_MODAL_WIDTH}
      footer={
        <div className={modalStyles.footerRow}>
          <Button type="secondary" onClick={onClose}>
            {t('delete-location-cancel')}
          </Button>
          <Button type="primary" onClick={onConfirm}>
            {t('delete-location-confirm')}
          </Button>
        </div>
      }
    >
      <div className={styles.body}>
        <p className={styles.message}>{t('delete-location-message', { name: locationName })}</p>
        <p className={styles.warning}>{t('delete-location-warning')}</p>
      </div>
    </Modal>
  );
};
